import { render, staticRenderFns } from "./autocomplete-cfm.vue?vue&type=template&id=80b7e0a8&scoped=true"
import script from "./autocomplete-cfm.vue?vue&type=script&lang=js"
export * from "./autocomplete-cfm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7e0a8",
  null
  
)

export default component.exports